
import { mapState, mapGetters } from 'vuex';
import AuthorGrade from '@/enums/AuthorGrade';
import ReviewContentType from '@/enums/ReviewContentType';

export default {
  name: 'AppReviewInfoSectionListMobile',
  props: {
    review: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      collapsed: true,
      messageRowsCount: -1
    };
  },
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('reviewSettings', [
      'isAuthorDisplayTypeUserGrade',
      'isAuthorDisplayTypeAuthorType'
    ]),
    expandedMessage() {
      if (
        this.widget.use_review_keyword_filter &&
        this.review.filtered_message_with_highlight
      )
        return this.review.filtered_message_with_highlight.replace(
          /==(.*?)==/g,
          '<mark>$1</mark>'
        );
      return this.review.filtered_message;
    },
    collapsedMessage() {
      if (!this.collapseAllMessage) return this.expandedMessage;

      let storeName = '';
      if (this.reviewSettings.show_store_name_prefix && this.review.store_name)
        storeName = `[${this.review.store_name}] `;
      return storeName + this.widget.collapsed_title;
    },
    collapseAllMessage() {
      return this.widget.message_initial_rows === 0;
    },
    collapsePartialMessage() {
      return this.widget.message_initial_rows > 0;
    },
    visibleRows() {
      return Math.min(this.messageRowsCount, this.widget.message_initial_rows);
    },
    collapsible() {
      if (this.review.content_type === ReviewContentType.RESTRICTED)
        return false;
      if (this.collapseAllMessage) return true;
      if (this.collapsePartialMessage) {
        if (
          this.messageRowsCount > this.widget.message_initial_rows ||
          this.review.evaluation_properties?.length > 0
        )
          return true;
      }
      return false;
    },
    shouldDisplayReviewOptions() {
      return (
        !!this.review.customer_properties &&
        this.review.customer_properties.length > 0
      );
    },
    shouldDisplayProductOptions() {
      return (
        this.reviewSettings.show_options &&
        this.review.product_options?.length > 0
      );
    },
    userReviewOption() {
      if (this.isAuthorDisplayTypeUserGrade && this.review.brand_user_grade) {
        return {
          name: this.$t('user_grade'),
          value: this.review.brand_user_grade.name
        };
      }

      if (this.isAuthorDisplayTypeAuthorType && this.review.brand_author_type) {
        return {
          name: this.$t('author_grade'),
          value: this.review.brand_author_type.title
        };
      }

      if (this.isAuthorDisplayTypeAuthorType && this.review.author_grade) {
        return {
          name: this.$t('author_grade'),
          value: AuthorGrade.t(this.review.author_grade)
        };
      }

      return null;
    }
  },
  watch: {
    messageRowsCount(newRowsCount, oldRowsCount) {
      const initialRows = this.widget.message_initial_rows;
      if (oldRowsCount > initialRows && newRowsCount > initialRows) return;
      if (oldRowsCount <= initialRows && newRowsCount <= initialRows) return;

      this.collapsed = this.collapsible;
    }
  },
  mounted() {
    if (this.collapsePartialMessage) {
      window.addEventListener('resize', this.calcMessageRowsCount);
      setTimeout(() => {
        this.calcMessageRowsCount();
      });
    }
    this.collapsed = this.collapsible;
  },
  beforeDestroy() {
    if (this.collapsePartialMessage) {
      window.removeEventListener('resize', this.calcMessageRowsCount);
    }
  },
  methods: {
    clickMessageToggle() {
      if (!this.collapsible) return;
      this.collapsed = !this.collapsed;
    },
    calcMessageRowsCount() {
      const collapsedHeight = this.$refs.collapsed_message.scrollHeight;
      const exposedHeight = this.$refs.exposed_message.scrollHeight;
      const newMaxHeight =
        collapsedHeight === 0 ? exposedHeight : collapsedHeight;

      const messageLineHeight = 20;
      const newMessageRowsCount = newMaxHeight / messageLineHeight;
      if (newMessageRowsCount === this.messageRowsCount) return;

      this.messageRowsCount = newMessageRowsCount;
    }
  }
};
